<template>
  <div v-if="!showDetails">
    <div v-if="isMobile">
      <app-history v-for="index in history.length" :key="index" :index="index - 1" :item="history[index - 1]"
        :selectedItem="selectedItem" @clicked="onClickItem" @callDownload="callDownload" @showArzyabi="showArzyabi">
      </app-history>
    </div>
    <div v-else>
      <v-data-table :items="history" item-key="Fserial" :headers="historyHeaders" class="elevation-1 rounded"
        :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText" show-expand>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>توضيحات: </b>
            <span v-html="item.Comment"></span>

            <br />
            <br />
            <b> مشاهده نتایج ارزیابی: </b>
            <div class="indent">
              <br />
              <b> ارزیابی اول: </b>
              <div class="indent">
                <br />
                <template v-if="item.Arzyab1 != ''">
                  <!-- <b>نام استاد:</b>
                  {{ item.Arzyab1 }} -->
                  <a @click="showArzyabi(item.Form1Serial)"> نتایج ارزیابی </a>
                  {{ item.Emtiaz1 }}
                </template>
                <template v-else> ---- </template>
                <br />
              </div>
              <br />
              <b> ارزیابی دوم: </b>
              <div class="indent">
                <br />
                <template v-if="item.Arzyab2 != ''">
                  <!-- <b>نام استاد:</b>
                  {{ item.Arzyab2 }} -->
                  <a @click="showArzyabi(item.Form2Serial)"> نتایج ارزیابی </a>
                  {{ item.Emtiaz2 }}
                </template>
                <template v-else> ---- </template>
                <br />
              </div>
              <br />
              <b> ارزیابی سوم: </b>
              <div class="indent">
                <br />
                <template v-if="item.Arzyab3 != ''">
                  <!-- <b>نام استاد:</b>
                  {{ item.Arzyab3 }} -->
                  <a @click="showArzyabi(item.Form3Serial)"> نتایج ارزیابی </a>
                  {{ item.Emtiaz3 }}
                </template>
                <template v-else> ---- </template>
                <br />
              </div>
            </div>
            <br />
            <b>نظر مسئول آموزش مدرسه برگزارکننده:</b>
            {{ item.StrState }}
            <br />
            <br />

            <a v-if="item.HasFile" @click="callDownload(item.Fserial, item.HashToken)"><b>دانلود صوت آزمون شفاهي</b>
            </a>
            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
  <div v-else>
    <v-data-table :items="emtiazDetails" :headers="emtiazHeaders" class="elevation-1 rounded" :disable-pagination="true"
      :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps" :mobile-breakpoint="1024">
    </v-data-table>
  </div>
</template>

<script>
import History from "./History";
import { downloadAttach, getShafahiHistory } from "@/api/shafahi";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appHistory: History,
  },
  data() {
    return {
      selectedItem: -1,
      history: [],
      showDetails: false,
      historyHeaders: [
        {
          text: "نام درس",
          value: "Reshte",
          width: "20%",
        },
        {
          text: "مدرسه برگزار کننده آزمون",
          value: "School",
          width: "30%",
        },
        {
          text: "نوع آزمون",
          value: "StrKExam",
          width: "10%",
        },
        {
          text: "تاریخ",
          value: "DDate",
          width: "10%",
        },
        {
          text: "زمان",
          value: "DTime",
          width: "10%",
        },
        {
          text: "مكان/ لينك مجازي",
          value: "Place",
          width: "15%",
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
      emtiazHeaders: [
        {
          text: "پرسش ",
          value: "Question",
          width: "35%",
        },
        {
          text: "گزینه",
          value: "Option",
          width: "15%",
        },
        {
          text: "بارم",
          value: "Barom",
          width: "10%",
        },
        {
          text: "توضیحات",
          value: "Tashrihi",
          width: "40%",
        },
      ],
      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
    };
  },
  created() {
    getShafahiHistory()
      .then((response) => {
        const data = response.data;
        this.history = data;
        this.$store.commit("SET_TABLE_TEXT", false);
      })
      .catch((error) => {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
        );
      });
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    emtiazDetails() {
      return this.$store.getters.tadrisPermissionEmtiazDetails;
    },
  },
  methods: {
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    showArzyabi(formSerial) {

      this.$store.dispatch("getEmtiazDetails", formSerial);
       window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showDetails: "true"
        }
      });
    },
    callDownload(index, token) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(index, token)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  watch: {

    '$route'(to, from) {
      this.showDetails = !!this.$route.query.showDetails;
    }
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}

.indent {
  margin-right: 30px;
}
</style>
